import React from "react";
import { Row, Col } from 'antd';
import { CaretUpOutlined } from '@ant-design/icons';
import { Expander, ItemList } from './styles';

export default ({ line, lineExpand, list, callback }) => {
    if (line == lineExpand) {
        return (
            <Row align={"middle"} wrap={false}>
                <Col flex="auto">{list.map((item, index) => (<ItemList key={index}>{item}</ItemList>))}</Col>
                <Col flex="20px">{<Expander onClick={() => callback()}><CaretUpOutlined /></Expander>}</Col>
            </Row>
        )
    } else {
        return (
            <Row align={"middle"} wrap={false}>
                <Col flex="auto"><ItemList>{list[0]}</ItemList></Col>
                <Col>{list.length > 1 ? <Expander onClick={() => callback()}>{`+${list.length - 1}`}</Expander> : null}</Col>
            </Row>
        )
    }
}